import { extend } from "@mongez/localization";
import {
  arValidationTranslation,
  enValidationTranslation,
} from "@mongez/react-form";
import { merge } from "@mongez/reinforcements";
import aboutUs from "./about-us.json";
import careers from "./careers.json";
import contactUs from "./contact-us.json";
import financialInformation from "./financial-information.json";
import generalAssembly from "./general-assembly.json";
import home from "./home.json";
import investor from "./investor.json";
import meta from "./meta.json";
import newsletters from "./newsletters.json";
import persons from "./persons.json";
import sectors from "./sectors.json";
import global from "./translations.json";

const languages = ["en", "ar"];

export const supportedLanguages = [...languages];

export type Language = (typeof languages)[number];

export const returnLanguageIfSupported = (
  lang?: string,
): Language | undefined => {
  if (supportedLanguages.includes(lang as Language)) {
    return lang as Language;
  }
  return undefined;
};

extend("en", { validation: enValidationTranslation });

extend("ar", { validation: arValidationTranslation });

// add your translation json file here
export const translation = merge(
  global,
  home,
  aboutUs,
  sectors,
  careers,
  contactUs,
  investor,
  financialInformation,
  generalAssembly,
  newsletters,
  persons,
  meta,
);
